import { render, staticRenderFns } from "./finalizarHistoria.vue?vue&type=template&id=056ecb7e&scoped=true"
import script from "./finalizarHistoria.vue?vue&type=script&lang=js"
export * from "./finalizarHistoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ecb7e",
  null
  
)

export default component.exports